import SectionHeading from '../components/SectionHeading';
import StepCard from '../components/StepCard';

const steps = [
  {
    icon: '📖',
    title: 'Learn',
    description:
      'Bite-sized lessons teach you the language of empathic communication in just minutes a day — no jargon, just real skills.',
  },
  {
    icon: '🎮',
    title: 'Practice',
    description:
      'Interactive games, quizzes, and an AI tutor help you turn knowledge into muscle memory.',
  },
  {
    icon: '🤝',
    title: 'Connect',
    description:
      "When you're ready, join live empathy sessions with real people for authentic practice.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="ee-landing-section ee-landing-section--warm">
      <div className="ee-landing-container ee-landing-container--narrow">
        <SectionHeading
          title="How It Works"
          subtitle="Three simple steps to transform how you communicate."
        />

        <div className="ee-landing-grid ee-landing-grid--3">
          {steps.map((step, index) => (
            <StepCard
              key={step.title}
              step={index + 1}
              icon={step.icon}
              title={step.title}
              description={step.description}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
